import React from 'react';
import './ServicesOurProcessSection.css';
import PropTypes from 'prop-types';

export default function ServicesOurProcessSection({ title, steps }) {
  return (
    <section className="process2-section">
      <h2 className="process2-title">{title}</h2>
      <div className="process2-timeline">
        {steps.map((step, index) => (
          <div className="process2-step" key={index}>
            <div className="process2-icon">{step.icon}</div>
            <div className="process2-content">
              <h3 className="process2-step-title">{step.title}</h3>
              <p className="process2-step-description">{step.description}</p>
            </div>
            {index !== steps.length - 1 && <div className="process2-line" />}
          </div>
        ))}
      </div>
    </section>
  );
}

// Define prop types outside of the component
ServicesOurProcessSection.propTypes = {
  title: PropTypes.string.isRequired,
  steps: PropTypes.arrayOf(
    PropTypes.shape({
      icon: PropTypes.node.isRequired,
      title: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
    })
  ).isRequired,
};
